import { render, staticRenderFns } from "./com-site-list.vue?vue&type=template&id=67170354&scoped=true&"
import script from "./com-site-list.vue?vue&type=script&lang=js&"
export * from "./com-site-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67170354",
  null
  
)

export default component.exports